<template>
    <div>
        <div class="nav-scroller bg-white box-shadow">
            <nav class="nav nav-underline">
                <div class="nav-link">
                    <router-link class="nav-item" v-bind:to="{name:'show-building-navbar'}">Buildings</router-link>
                </div>
                <div class="nav-link">
                    <a class="nav-item" target="_blank" v-bind:href="plexusFrontendUsersAdminUrl">Users</a>
                </div>
            </nav>
        </div>
        <router-view></router-view>

    </div>
</template>

<script>
  export default {
    data () {
      return {
        account: {}
      }
    },
    mounted () {
      this.load()
    },
    methods: {
      load () {
      },
    },
    computed: {
      plexusFrontendUsersAdminUrl: function() {
        return this.$store.getters.getSection('fixture').frontend_url.replace(/\/$/, '') +  '/dev/users';
      },
    }
  }
</script>